module.exports = __webpack_public_path__ + "img/coin.cf837b1c.png";